import user from "@/store/modules/authorization_store";

const getDefaultState = () => {
    return {
        homeCompanies: null,
        requestData: null,
        infoOffer: null,
        infoUser: null,
        fullOrderInfo: null,
        contractId: null,
        houseInfo: null,
    }
};

const state = getDefaultState();

const getters = {
    HOME_COMPANIES: state => state.homeCompanies,
    HOME_SEARCH_PARAMS: state => state.requestData,
    HOME_INFO_OFFER: state => state.infoOffer,
    HOME_INFO_USER: state => state.infoUser,
    HOME_FULL_ORDER: state => state.fullOrderInfo,
    HOME_CONTRACT_ID: state => state.contractId,
    HOME_HOUSE_INFO: state => state.houseInfo,
};

const mutations = {
    SET_HOME_COMPANIES: (state, data) => {
        state.homeCompanies = data;
    },
    SET_HOME_SEARCH_PARAMS: (state, data) => {
        state.requestData = data;
    },
    SET_HOME_INFO_OFFER: (state, data) => {
        state.infoOffer = data;
        localStorage.setItem(user.state.keyUser + '_home_infoOrder', JSON.stringify(data));
    },
    SET_HOME_INFO_USER: (state, data) => {
        state.infoUser = data;
    },
    SET_HOME_FULL_ORDER: (state, orderId) => {
        state.fullOrderInfo = {...state.requestData, ...state.infoOffer, ...{info: state.infoUser}, orderId};
        localStorage.setItem(user.state.keyUser + '_home_full_order_info', JSON.stringify(state.fullOrderInfo));
    },
    SET_HOME_CONTRACT_ID: (state, data) => {
        state.contractId = data;
    },
    SET_HOME_INFO_HOUSE: (state, data) => {
        state.houseInfo = data;
    },
    CLEAR_HOME_INFO_HOUSE: (state) => {
        state.houseInfo = null;
    },
    CLEAR_HOME_FULL_ORDER: (state) => {
        state.infoOffer = null;
        state.fullOrderInfo = null;
        localStorage.setItem(user.state.keyUser + '_home_infoOrder', null);
        localStorage.setItem(user.state.keyUser + '_home_full_order_info', null);
    },
    INIT_HOME_FULL_INFO_ORDER: (state) => {
        const savedData = localStorage.getItem(user.state.keyUser + '_home_full_order_info');
        if (savedData) {
            state.fullOrderInfo = JSON.parse(savedData);
        }
    },
    INIT_HOME_INFO_ORDER: (state) => {
        const savedData = localStorage.getItem(user.state.keyUser + '_home_infoOrder');
        if (savedData) {
            state.infoOffer = JSON.parse(savedData);
        }
    },
};

const actions = {
    initHomeFullInfoOrder({ commit }) {
        commit('INIT_HOME_FULL_INFO_ORDER'); // Загружаем данные из localStorage в state при старте
    },
    initHomeInfoOrder({ commit }) {
        commit('INIT_HOME_INFO_ORDER'); // Загружаем данные из localStorage в state при старте
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
};
